import { createSlice } from '@reduxjs/toolkit';

// Held a `filter` range of its own (start of year to today) that no reducer call ever updated, so
// the dashboard leave card was pinned to it while the effort cards followed the filter row. The
// leave card now reads the applied effort range directly, leaving nothing to store here (HRMS-264).
const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    rows: []
  },
  reducers: {
    replaceData(state, action) {
      state.rows = action.payload;
    },
  },
});

export const dashboardActions = dashboardSlice.actions;

export default dashboardSlice;